import type { IndexUiState } from 'instantsearch.js';

export type RefinementListItem = {
	value: string;
	label: string;
	highlighted?: string;
	count: number;
	isRefined: boolean;
};

export type LocationItemTypeEnum = 'city' | 'country';

export type LocationItem = RefinementListItem & {
	type: LocationItemTypeEnum;
};

export type SortByEnum = 'most_signatures' | 'least_signatures' | 'newest';

// Custom type for the route search state
export type CustomRouteSearchState = {
	q?: string;
	sort?: SortByEnum;
	page?: number;
	victory?: boolean;
	topics?: string;
	location_city?: string;
	location_country_code?: string;
	weekly_signature_count?: string;
};

export const SEARCH_QUERY_KEYS = Object.keys({
	q: true,
	sort: true,
	page: true,
	victory: true,
	topics: true,
	location_city: true,
	location_country_code: true,
	weekly_signature_count: true,
} satisfies Record<keyof CustomRouteSearchState, true>);

export const SEARCH_UI_STATE_KEYS = Object.keys({
	query: true,
	refinementList: true,
	toggle: true,
	range: true,
	sortBy: true,
} satisfies Partial<Record<keyof IndexUiState, true>>);
